<!--
    描述：专家预约记录
    日期：2021/01/19
    作者：zwh
-->
<template>
    <div class="Apage operation-layout">
        <div v-if="searchToggle">
            <div class="search" v-if="!routeQuery">
                <el-form :model="searchObj" label-width="130px">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="预约人：">
                                <el-input :placeholder="'请输入'"
                                          clearable
                                          v-model="searchObj.userSname"
                                          size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="预约单位：">
                                <el-input :placeholder="'请输入'"
                                          clearable
                                          v-model="searchObj.companyName"
                                          size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="事项：">
                                <el-select v-model="searchObj.applyItems" placeholder="请选择" clearable size="small">
                                    <el-option label="评标" value="评标"></el-option>
                                    <el-option label="评审" value="评审"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="项目名称：">
                                <el-input :placeholder="'请输入'"
                                          clearable
                                          v-model="searchObj.projectName"
                                          size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="抽取方式：">
                                <el-select v-model="searchObj.extractType" placeholder="请选择" clearable size="small">
                                    <el-option label="随机抽取" value="1"></el-option>
                                    <el-option label="指定抽取" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="预约时间：">
                                <el-date-picker
                                     v-model="searchObj.bookTime"
                                     type="daterange"
                                     unlink-panels
                                     size="small"
                                     start-placeholder="请选择"
                                     end-placeholder="请选择"
                                     :default-time="['00:00:00', '23:59:59']">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="抽取来源：">
                                <el-select v-model="searchObj.sysCode" placeholder="请选择" clearable size="small">
                                    <el-option label="能工社运营管理平台" value="1001"></el-option>
                                    <el-option label="能工社公共交易平台" value="1002"></el-option>
                                    <el-option label="安招采业务系统" value="1003"></el-option>
                                    <el-option label="专家评审项目" value="1004"></el-option>
                                    <el-option label="资源价格系统" value="1005"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="预约状态：">
                                <el-select v-model="searchObj.extractState" placeholder="请选择" clearable size="small">
                                    <el-option label="待完成" value="1"></el-option>
                                    <el-option label="部分完成" value="2"></el-option>
                                    <el-option label="全部完成" value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" class="text-center">
                            <el-button type="primary"
                                       class="btn-blue"
                                       size="small"
                                       @click="searchResult">搜索</el-button>
                            <el-button type="warning"
                                       size="small"
                                       @click="resetSearch">重置</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="operation-main" v-if="!routeQuery">
            <div class="operation-header">
                <div class="title">
                    预约记录合计： <span class="blue">{{tableObj.total}}</span> 条
                </div>
            </div>
            <div class="operation-container w-table-layout w-table-page">
                <div class="w-table-content">
                    <el-table ref="xTable"
                              :data="tableObj.data"
                              highlight-current-row
                              height="100%"
                              border>
                        <el-table-column type="index"
                                         label="序号"
                                         align="center"
                                         width="80"></el-table-column>
                        <el-table-column prop="serialNo"
                                         label="预约流水号"
                                         header-align="center"
                                         width="150"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="createDate"
                                         label="预约时间"
                                         header-align="center"
                                         width="150"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="applyItems"
                                         label="事项"
                                         header-align="center"
                                         width="100"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="useStartTime"
                                         label="预约时间"
                                         align="center"
                                         width="160"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="projectName"
                                         label="项目名称"
                                         header-align="center"
                                         min-width="180"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="companyName"
                                         label="预约单位"
                                         header-align="center"
                                         width="180"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="userSname"
                                         label="预约人"
                                         align="center"
                                         width="100"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="persons"
                                         label="抽取总人数"
                                         align="right"
                                         width="100"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="extractType"
                                         label="抽取方式"
                                         header-align="center"
                                         width="110"
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.extractType==1">随机抽取</span>
                                <span v-if="scope.row.extractType==2">指定抽取</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sysCode"
                                         label="抽取来源"
                                         header-align="center"
                                         width="160"
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.sysCode==1001">能工社运营管理平台</span>
                                <span v-if="scope.row.sysCode==1002">能工社公共交易平台</span>
                                <span v-if="scope.row.sysCode==1003">安招采业务系统</span>
                                <span v-if="scope.row.sysCode==1004">专家评审项目</span>
                                <span v-if="scope.row.sysCode==1005">资源价格系统</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="extract"
                                         label="预约状态"
                                         align="center"
                                         width="120"
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.extractState==1" style="color:red;font-weight:bold;">待完成</span>
                                <span v-if="scope.row.extractState==2" style="color:blue;font-weight:bold;">部分完成</span>
                                <span v-if="scope.row.extractState==3" style="color:#3B9A00;font-weight:bold;">全部完成</span>
                                <span v-if="scope.row.extractState==-1" style="color:#000;font-weight:bold;">数据异常</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center"
                                         width="100">
                            <template slot="header">操作</template>
                            <template slot-scope="scope">
                                <!-- <el-row>
                                    <span class="b-text"
                                          @click="detailView(scope.row)">
                                        <i class="el-icon-edit"></i>详情
                                    </span>
                                </el-row> -->
                                <el-button type="primary"
                                           size="small"
                                           round
                                           plain
                                           class="table-btn"
                                           v-if="roleBtns.includes('expertAppointmentDetail')"
                                           @click="detailView(scope.row)">
                                    <svg-icon icon-class="form-details"></svg-icon> 详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="w-table-footer">
                    <el-pagination @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="tableObj.currentPage"
                                   :page-sizes="tableObj.pageList"
                                   :page-size="tableObj.pageSize"
                                   :total="tableObj.total"
                                   layout="total, sizes, prev, pager, next, jumper">
                    </el-pagination>
                </div>
             </div>
        </div>

        <div  class="operation-main" v-if="routeQuery">
            <reply-detail ref="replyDetail"></reply-detail>
        </div>
    </div>
</template>
<script>
import { dateFormat } from 'utils/tools'
import { getExpertsRecordsReplyPageList } from 'api/modules/expertsRecordsReply'
import replyDetail from './components/reply-detail'
import { mapState } from 'vuex'
export default {
    name : '',
    components: {
        replyDetail,
    },
    data() {
        return {
            searchToggle: true,
            loading : true,
            searchObj : {
                userName : '',
                userSname : '',
                applyItems : '',
                projectItem : '',
                companyName : '',
                extractType : '',
                bookTime : '',
                useStartTime : '',
                useEndTime : '',
                extractState : '',
            },
            tableObj : {
                data : [],
                currentPage: 1, // 当前页码
                pageList: [10, 20, 50, 100], // 显示条数数组
                pageSize: 10, // 当前显示条数
                total: 0, // 当前总条数
            },
        }
    },
    computed: {
        ...mapState('app', { isBack: state => state.isBack }),
        ...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
        routeQuery() {
            return this.$route.query.type
        },
    },
    created() {
        // 如果是 返回的
        if (this.isBack) {
			if (this.$getSessionItem("searchForm")) {
				this.searchObj = JSON.parse(this.$getSessionItem("searchForm"))

				// 移除 避免污染
				this.$removeSessionItem("searchForm")
            }
            
			if (this.$getSessionItem("currentPage")) {
				this.tableObj.currentPage = JSON.parse(this.$getSessionItem("currentPage"))

				// 移除 避免污染
				this.$removeSessionItem("currentPage")
			}

			if (this.$getSessionItem("pageSize")) {
				this.tableObj.pageSize = JSON.parse(this.$getSessionItem("pageSize"))

				// 移除 避免污染
				this.$removeSessionItem("pageSize")
			}
		}
        this.getTablePageList()
    },
    methods: {
        searchResult(){
            this.tableObj.currentPage = 1
            this.tableObj.pageSize = 10
            this.getTablePageList()
        },
        getTablePageList(){
            if(this.searchObj.bookTime != "" && this.searchObj.bookTime != null){
                //this.searchObj.useStartTime = new Date(dateFormat('',this.searchObj.bookTime[0]))
                //this.searchObj.useEndTime = new Date(dateFormat('',this.searchObj.bookTime[1]))
                //this.searchObj.useStartTime = this.searchObj.bookTime[0]
                //this.searchObj.useEndTime = this.searchObj.bookTime[1]
                this.searchObj.useStartTime = dateFormat('',this.searchObj.bookTime[0])
                this.searchObj.useEndTime = dateFormat('',this.searchObj.bookTime[1])
            }else {
                this.searchObj.useStartTime = ''
                this.searchObj.useEndTime= ''
            }
            let params = Object.assign({}, this.searchObj)
            this.loading = true
            // 分页参数
            params.current = this.tableObj.currentPage
            params.size = this.tableObj.pageSize
            getExpertsRecordsReplyPageList(params).then((res) => {
                this.loading = false
                this.tableObj.data = res.data.records
                this.tableObj.currentPage = parseInt(res.data.current)
                this.tableObj.total = parseInt(res.data.total)
                this.tableObj.pageSize = parseInt(res.data.size)
            })
            .catch((err) => {
                this.loading = false
            })
        },
        detailView(row){
            // 存值
            this.$setSessionItem("searchForm", JSON.stringify(this.searchObj));
            this.$setSessionItem("currentPage", JSON.stringify(this.tableObj.currentPage));
            this.$setSessionItem("pageSize", JSON.stringify(this.tableObj.pageSize));

            this.$router.push({
                name: 'experts-records-reply',
                query: {
                    type: 'detail',
                    id: row.id,
                },
            })
        },
        resetSearch(){
            this.tableObj.currentPage = 1
            this.tableObj.pageSize = 10
            this.searchObj = {}
            this.getTablePageList()
        },
        // 切换显示条数
        handleSizeChange(val) {
            this.tableObj.pageSize = val
            this.getTablePageList()
        },

        //切换当前页码
        handleCurrentChange(val) {
            this.tableObj.currentPage = val
            this.getTablePageList()
        },
    }
}
</script>
<style lang="less">
.search {
    border-bottom: 1px solid #2671cc;
}
</style>